(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prevura-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('.pv-reviews__more');
    if (details) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-app-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pv-app-guide')){customElements.define('pv-app-guide',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];const select=(n,focus)=>{this.tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;this.panels[i].hidden=i!==n;});if(focus)this.tabs[n].focus();};this.addEventListener('click',e=>{const t=e.target.closest('[role=tab]');if(t)select(this.tabs.indexOf(t),false);});this.addEventListener('keydown',e=>{const i=this.tabs.indexOf(e.target);if(i<0)return;let n=i;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(i+this.tabs.length-1)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();select(n,true);});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-how-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pv-how-journey')) {
  customElements.define('pv-how-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const select = index => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); select(next); tabs[next].focus();
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-pdp-course-path"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get("pv-course-path"))return;
class PvCoursePath extends HTMLElement {
  #abortController = null;
  #scrollFrame = null;
  #activeIndex = 0;
  #demoObserver = null;
  #demoTimers = [];
  #demoFinished = false;

  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const signal = this.#abortController.signal;
    this.track = this.querySelector('[data-course-track]');
    this.cards = Array.from(this.querySelectorAll('[data-course-card]'));
    this.targets = Array.from(this.querySelectorAll('[data-course-target]'));
    this.current = this.querySelector('[data-course-current]');
    this.progress = this.querySelector('[data-course-progress]');
    this.previous = this.querySelector('[data-course-prev]');
    this.next = this.querySelector('[data-course-next]');
    this.flips = Array.from(this.querySelectorAll('[data-course-flip]'));
    this.dots = Array.from(this.querySelectorAll('[data-course-dot]'));

    if (!this.track || this.cards.length === 0) return;

    this.track.addEventListener('scroll', this.#onScroll, { signal, passive: true });
    this.track.addEventListener('keydown', this.#onKeydown, { signal });
    this.track.addEventListener('pointerdown', this.#cancelDemo, { signal, passive: true });
    this.previous?.addEventListener('click', () => { this.#cancelDemo(); this.goTo(this.#activeIndex - 1); }, { signal });
    this.next?.addEventListener('click', () => { this.#cancelDemo(); this.goTo(this.#activeIndex + 1); }, { signal });
    this.targets.forEach((button, index) => button.addEventListener('click', () => { this.#cancelDemo(); this.goTo(index); }, { signal }));
    this.dots.forEach((dot, index) => {
      if (!(dot instanceof HTMLButtonElement)) return;
      dot.addEventListener('click', () => { this.#cancelDemo(); this.goTo(index); }, { signal });
    });
    this.flips.forEach((button, index) => button.addEventListener('click', () => { this.#cancelDemo(); this.#toggleCard(index); }, { signal }));
    this.#setActive(0);
    this.#setupDemo();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#demoObserver?.disconnect();
    this.#demoObserver = null;
    this.#clearDemoTimers();
    if (this.#scrollFrame) cancelAnimationFrame(this.#scrollFrame);
    this.#scrollFrame = null;
  }

  goTo(index) {
    const normalized = Math.max(0, Math.min(index, this.cards.length - 1));
    const target = this.cards[normalized];
    if (!target || !this.track) return;
    if (this.track.scrollWidth > this.track.clientWidth + 2) {
      const left = target.offsetLeft - ((this.track.clientWidth - target.clientWidth) / 2);
      this.track.scrollTo({
        left,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    } else {
      target.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    this.#setActive(normalized);
  }

  #onScroll = () => {
    if (this.#scrollFrame) cancelAnimationFrame(this.#scrollFrame);
    this.#scrollFrame = requestAnimationFrame(() => {
      this.#scrollFrame = null;
      const trackCenter = this.track.scrollLeft + (this.track.clientWidth / 2);
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      this.cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + (card.clientWidth / 2);
        const distance = Math.abs(cardCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      this.#setActive(closestIndex);
    });
  };

  #onKeydown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    this.#cancelDemo();
    const focusedIndex = this.flips.indexOf(event.target);
    const currentIndex = focusedIndex >= 0 ? focusedIndex : this.#activeIndex;
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(currentIndex + direction, this.cards.length - 1));
    this.goTo(nextIndex);
    if (focusedIndex >= 0) this.flips[nextIndex]?.focus({ preventScroll: true });
  };

  #setActive(index) {
    const normalized = Math.max(0, Math.min(index, this.cards.length - 1));
    this.#activeIndex = normalized;
    if (this.current) this.current.textContent = `Woche ${normalized + 1} von ${this.cards.length}`;
    if (this.progress) {
      const progress = this.cards.length > 1 ? (normalized / (this.cards.length - 1)) * 100 : 100;
      this.progress.style.width = `${progress}%`;
    }
    this.cards.forEach((card, cardIndex) => { card.dataset.active = cardIndex === normalized ? 'true' : 'false'; });
    this.targets.forEach((button, buttonIndex) => {
      if (buttonIndex === normalized) {
        button.setAttribute('aria-current', 'step');
        button.dataset.state = 'current';
      } else {
        button.removeAttribute('aria-current');
        button.dataset.state = buttonIndex < normalized ? 'done' : 'upcoming';
      }
    });
    this.dots.forEach((button, buttonIndex) => {
      if (buttonIndex === normalized) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
    if (this.previous instanceof HTMLButtonElement) this.previous.disabled = normalized === 0;
    if (this.next instanceof HTMLButtonElement) this.next.disabled = normalized === this.cards.length - 1;
  }

  #toggleCard(index) {
    const selectedCard = this.cards[index];
    if (!selectedCard) return;
    const shouldFlip = selectedCard.dataset.flipped !== 'true';
    this.#setCardFlip(index, shouldFlip);
    this.#setActive(index);
  }

  #setCardFlip(index, shouldFlip) {
    this.cards.forEach((card, cardIndex) => {
      const flipped = cardIndex === index && shouldFlip;
      card.dataset.flipped = flipped ? 'true' : 'false';
      const button = this.flips[cardIndex];
      if (button instanceof HTMLButtonElement) {
        button.setAttribute('aria-pressed', flipped ? 'true' : 'false');
        const front = card.querySelector('.pv-pdp-course-path__face--front');
        const back = card.querySelector('.pv-pdp-course-path__face--back');
        front?.setAttribute('aria-hidden', flipped ? 'true' : 'false');
        back?.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      }
    });
  }

  #setupDemo() {
    if (this.#demoFinished || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const demoTarget = this.cards[0] || this;
    this.#demoObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry?.isIntersecting || entry.intersectionRatio < 0.7) return;
      this.#demoObserver?.disconnect();
      this.#demoObserver = null;
      const openTimer = window.setTimeout(() => {
        if (this.#demoFinished) return;
        this.#setCardFlip(this.#activeIndex, true);
      }, 650);
      const closeTimer = window.setTimeout(() => {
        if (this.#demoFinished) return;
        this.#setCardFlip(this.#activeIndex, false);
        this.#demoFinished = true;
        this.#clearDemoTimers();
      }, 2200);
      this.#demoTimers.push(openTimer, closeTimer);
    }, { threshold: [0.7] });
    this.#demoObserver.observe(demoTarget);
  }

  #clearDemoTimers() {
    this.#demoTimers.forEach((timer) => window.clearTimeout(timer));
    this.#demoTimers = [];
  }

  #cancelDemo = () => {
    if (this.#demoFinished) return;
    this.#demoFinished = true;
    this.#demoObserver?.disconnect();
    this.#demoObserver = null;
    this.#clearDemoTimers();
  }
}


customElements.define("pv-course-path",PvCoursePath);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-pillow-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pv-pillow-explorer')) {
  class PillowExplorer extends HTMLElement {
    static viewerPromise;
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.classList.add('is-enhanced');
      this.amount = 0;
      this.angle = 32;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.start = this.querySelector('.pv-explore__start');
      this.startLabel = this.start.innerHTML;
      this.status = this.querySelector('.pv-explore__status');
      this.slider = this.querySelector('input[type=range]');
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.matches('.pv-explore__start')) { if (await this.load()) this.animateTo(0); return; }
        if (button.dataset.mode !== undefined) {
          if (await this.load()) {
            const target = Number(button.dataset.mode);
            this.selectLayer(target === 0 ? 'cover' : target === .45 ? 'inner' : 'core');
            this.animateTo(target);
          }
        } else if (button.dataset.layer) {
          this.selectLayer(button.dataset.layer);
          if (await this.load()) {
            this.selectLayer(button.dataset.layer);
            this.animateTo({ cover: 0, inner: .45, core: 1 }[button.dataset.layer]);
          }
        } else if (button.dataset.turn) {
          this.angle += Number(button.dataset.turn); this.camera();
        } else if (button.hasAttribute('data-reset')) {
          this.angle = 32; this.selectLayer(''); this.animateTo(0); this.camera();
        }
      }, { signal: this.abort.signal });
      this.slider.addEventListener('input', () => {
        cancelAnimationFrame(this.frame);
        this.setAmount(Number(this.slider.value) / 100);
        this.selectLayer(this.amount < .225 ? 'cover' : this.amount < .725 ? 'inner' : 'core');
      }, { signal: this.abort.signal });
      this.resize = new ResizeObserver(() => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(async () => {
          if (!this.ready || !this.isConnected) return;
          const width = this.querySelector('.pv-explore__stage').clientWidth;
          if (this.lastStageWidth && Math.abs(width - this.lastStageWidth) > 2) {
            const amount = this.amount;
            const layer = this.selectedLayer;
            this.lastStageWidth = width;
            this.ready = false;
            this.classList.remove('is-ready');
            if (await this.load()) { this.animateTo(amount); this.selectLayer(layer); }
          } else {
            this.lastStageWidth = width;
            this.camera();
          }
        }, 120);
      });
      this.resize.observe(this.querySelector('.pv-explore__stage'));
      const autoLoad = async () => {
        if (await this.load()) {
          if (this.isConnected) this.animateTo(this.amount);
        }
      };
      if ('IntersectionObserver' in window) {
        this.approach = new IntersectionObserver((entries) => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.approach.disconnect();
          void autoLoad();
        }, { rootMargin: '800px 0px', threshold: 0 });
        this.approach.observe(this.querySelector('.pv-explore__stage'));
      } else {
        void autoLoad();
      }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.approach?.disconnect();
      this.resize?.disconnect(); clearTimeout(this.resizeTimer); cancelAnimationFrame(this.frame);
      clearTimeout(this.loadTimer);
    }
    async load() {
      if (this.ready) return true;
      if (this.loading) return this.loading;
      this.loading = this.loadModel();
      const result = await this.loading;
      this.loading = null;
      return result;
    }
    async loadModel() {
      this.classList.remove('has-error');
      this.start.disabled = true;
      this.start.textContent = this.dataset.loading;
      this.status.textContent = this.dataset.loading;
      try {
        if (!customElements.get('model-viewer')) {
          if (!PillowExplorer.viewerPromise) PillowExplorer.viewerPromise = new Promise((resolve, reject) => {
            if (!window.Shopify?.loadFeatures) { reject(new Error('viewer unavailable')); return; }
            window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: (errors) => {
              if (errors?.length) reject(new Error('viewer unavailable'));
              else customElements.whenDefined('model-viewer').then(resolve);
            }}]);
          });
          await Promise.race([PillowExplorer.viewerPromise, new Promise((_, reject) => {
            this.loadTimer = setTimeout(() => reject(new Error('load timeout')), 30000);
          })]);
          clearTimeout(this.loadTimer);
        }
        if (!this.isConnected) return false;
        this.querySelector('.pv-explore__mount').replaceChildren();
        this.viewer = this.querySelector('.pv-explore__model-template').content.firstElementChild.cloneNode(true);
        const loaded = new Promise((resolve, reject) => {
          this.viewer.addEventListener('load', resolve, { once: true });
          this.viewer.addEventListener('error', reject, { once: true });
          this.loadTimer = setTimeout(() => reject(new Error('model timeout')), 45000);
        });
        this.viewer.src = this.dataset.modelUrl;
        this.querySelector('.pv-explore__mount').append(this.viewer);
        await loaded; clearTimeout(this.loadTimer);
        if (!this.isConnected) return false;
        if (!this.viewer.availableAnimations?.length) throw new Error('animation missing');
        this.viewer.animationName = this.viewer.availableAnimations[0];
        this.viewer.pause();
        this.ready = true;
        this.lastStageWidth = this.querySelector('.pv-explore__stage').clientWidth;
        this.setAmount(0);
        this.selectLayer('cover');
        this.classList.add('is-ready');
        this.start.hidden = true;
        this.querySelector('.pv-explore__scrub').hidden = false;
        this.querySelector('.pv-explore__tools').hidden = false;
        this.querySelector('.pv-explore__fine').hidden = false;
        this.status.textContent = this.dataset.ready;
        return true;
      } catch {
        clearTimeout(this.loadTimer);
        PillowExplorer.viewerPromise = null;
        this.viewer?.remove();
        this.start.disabled = false;
        this.start.innerHTML = this.startLabel;
        this.classList.add('has-error');
        this.status.textContent = this.dataset.loadError;
        return false;
      }
    }
    camera() {
      if (!this.viewer) return;
      const stage = this.querySelector('.pv-explore__stage').getBoundingClientRect();
      const radius = Math.max(1.07, 1.08 * stage.height / Math.max(stage.width, 1));
      this.cameraRevision = (this.cameraRevision || 0) + 1;
      this.viewer.fieldOfView = `${30 + this.cameraRevision * .000001}deg`;
      this.viewer.cameraOrbit = `${this.angle}deg 62deg ${radius}m`;
      this.viewer.cameraTarget = '0m 0.048m 0m';
      if (this.reduced) this.viewer.jumpCameraToGoal();
    }
    selectLayer(layer) {
      layer = layer || 'cover';
      if (this.selectedLayer === layer) return;
      this.selectedLayer = layer;
      this.querySelectorAll('.pv-explore__layer').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.layer === layer)));
      this.querySelectorAll('.pv-explore__hotspot').forEach(button => button.classList.toggle('is-active', button.dataset.layer === layer));
      const selected = [...this.querySelectorAll('.pv-explore__layer')].find(button => button.dataset.layer === layer);
      if (selected) { this.querySelector('.pv-explore__detail h3').textContent = selected.querySelector('strong').textContent; this.querySelector('.pv-explore__detail p').textContent = selected.querySelector('.pv-explore__description').textContent; }
      this.status.textContent = selected ? `${selected.querySelector('strong').textContent} – ${selected.querySelector('.pv-explore__material').textContent}` : this.dataset.ready;
    }
    setAmount(value) {
      this.amount = Math.max(0, Math.min(1, value));
      if (this.viewer) this.viewer.currentTime = this.amount * Math.max(0, this.viewer.duration - .001);
      this.slider.value = String(Math.round(this.amount * 100));
      this.querySelector('output').textContent = `${this.slider.value} %`;
      this.slider.style.setProperty('--progress', `${this.slider.value}%`);
      this.classList.toggle('is-open', this.amount > .92);
      const mode = this.amount < .225 ? 0 : (this.amount < .725 ? .45 : 1);
      this.querySelectorAll('[data-mode]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.mode) === mode)));
      this.camera();
    }
    animateTo(value) {
      cancelAnimationFrame(this.frame);
      if (this.reduced) { this.setAmount(value); return; }
      const from = this.amount;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min((now - start) / 1450, 1);
        const ease = t * t * (3 - 2 * t);
        this.setAmount(from + (value - from) * ease);
        if (t < 1) this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
  }
  customElements.define('pv-pillow-explorer', PillowExplorer);
}


  } catch(e) { console.error(e); }
})();
})();
